import React from 'react';
import PropTypes from 'prop-types';
import Button from 'relements/build/esm/ui/button';
import Icon from 'relements/build/esm/ui/icon';
import WithTooltip from 'relements/build/esm/overlays/withTooltip';

import RegularExpressionIcon from '../../icons/regex.svg';
import MatchCaseIcon from '../../icons/case.svg';
import styles from './Header.scss';

function Header({
  filtersOpen,
  onFilterClick,
  searchTerm,
  searchResults,
  status,
  matchCase,
  regex,
  onMatchCaseClick,
  onRegexClick,
  numFilters,
}) {
  const matchCaseActiveClassName = matchCase ? styles.active : '';
  const regexActiveClassName = regex ? styles.active : '';
  return (
    <div className={styles.header}>
      <div className={styles.headerColumn}>
        <Button
          type={!!numFilters && Button.TYPES.OUTLINE}
          outline={!!numFilters}
          disabled={filtersOpen}
          onClick={onFilterClick}
        >
          Apply Filter
          <div className={styles.headerNotification}>{numFilters || null}</div>
        </Button>
      </div>
      <div className={styles.headerColumn}>
        {searchTerm && status === 'RESULTS' ? (
          <React.Fragment>
            <span className={styles.headerTitle}>
              {searchResults.length} results for &quot;{searchTerm}&quot;
            </span>
            {/* <Icon
              className={styles.headerIcon}
              iconType="info"
            /> */}
          </React.Fragment>
        ) : null}
      </div>
      <div className={styles.headerColumn}>
        <WithTooltip
          className={styles.withTooltip}
          tooltip="Regex"
          tooltipPosition="BOTTOM"
        >
          <Button
            type={regex && Button.TYPES.OUTLINE}
            onClick={() => onRegexClick(!regex)}
            className={styles.headerButton}
          >
            <Icon
              className={`${styles.headerIcon} ${regexActiveClassName}`}
              src={RegularExpressionIcon}
            />
          </Button>
        </WithTooltip>
        <WithTooltip
          className={styles.withTooltip}
          tooltip="Match Case"
          tooltipPosition="BOTTOM"
        >
          <Button
            type={matchCase && Button.TYPES.OUTLINE}
            onClick={() => onMatchCaseClick(!matchCase)}
            className={styles.headerButton}
          >
            <Icon
              className={`${styles.headerIcon} ${matchCaseActiveClassName}`}
              src={MatchCaseIcon}
            />
          </Button>
        </WithTooltip>
      </div>
    </div>
  );
}

Header.propTypes = {
  searchTerm: PropTypes.string,
  status: PropTypes.string,
  filtersOpen: PropTypes.bool,
  matchCase: PropTypes.bool,
  regex: PropTypes.bool,
  onFilterClick: PropTypes.func,
  onMatchCaseClick: PropTypes.func,
  onRegexClick: PropTypes.func,
  numFilters: PropTypes.number,
  searchResults: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      match_string: PropTypes.string,
      match_indexes: PropTypes.string,
      match_pattern: PropTypes.string,
      node_name: PropTypes.string,
    })
  ),
};

Header.defaultProps = {
  filtersOpen: false,
  matchCase: false,
  onFilterClick: () => {},
  onMatchCaseClick: () => {},
  onRegexClick: () => {},
  regex: false,
  searchResults: [],
  searchTerm: '',
  status: '',
  numFilters: 0,
};

export default Header;
